import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetRewardProgramByOrganizationId = ({
  organizationId,
  enabled = true,
}: {
  organizationId: number
  enabled?: boolean
}): UseQueryResult<Array<components['schemas']['FullRewardsProgramDTO']>> => {
  const get = useTypedApiClient({
    path: '/admin/rewards-programs/organization/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/rewards-programs/organization/{id}', organizationId],
    queryFn: async () => {
      const { data } = await get({ id: organizationId })
      return data
    },
    enabled,
  })
}
